export default "__VITE_ASSET__lhw03pLV__"